import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const config = {
  apiKey: "AIzaSyCWm0ZmQfgmqEqGuFFQqfkewU58d2V-14c",
  authDomain: "custom-app-project-test.firebaseapp.com",
  databaseURL: "https://custom-app-project-test.firebaseio.com/",
  projectId: "custom-app-project-test",
  storageBucket: "custom-app-project-test.appspot.com",
  messagingSenderId: "981995534626",
};

const firebaseApp = initializeApp(config);

export const database = getDatabase(firebaseApp);
export const storage = getStorage(firebaseApp);

export const auth = getAuth(firebaseApp);

export const USER = () => auth.currentUser;

// Note: there is deliberately no `isAuth()` here any more. It read a snapshot
// of the SDK's own persistence key out of localStorage once, at module load,
// so it kept reporting the previous user after sign-out (until a full reload)
// and could be forged by hand. Route access now comes from the live
// onAuthStateChanged state in Redux (see verifyAuth and components/auth.js).
